import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"
import styled from "styled-components"

const StyledRoot = styled(SliderPrimitive.Root)`
  position: relative;
  display: flex;
  width: 100%;
  touch-action: none;
  user-select: none;
  align-items: center;
`;

const StyledTrack = styled(SliderPrimitive.Track)`
  position: relative;
  height: 6px;
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
  border-radius: 9999px;
  background-color: #E5E7EB;
`;

const StyledRange = styled(SliderPrimitive.Range)`
  position: absolute;
  height: 100%;
  background-color: var(--color-petrol);
`;

const StyledThumb = styled(SliderPrimitive.Thumb)`
  display: block;
  height: 28px;
  width: 28px;
  border-radius: 9999px;
  border: 3px solid var(--color-petrol);
  background-color: var(--color-white);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: border-color 0.15s;
  cursor: grab;
  &:hover {
    border-color: #007080;
  }
  &:active {
    cursor: grabbing;
  }
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px var(--color-petrol-25);
  }
  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, onMouseLeave, onTouchEnd, ...props }, ref) => (
  <StyledRoot
    ref={ref}
    className={className}
    {...props}
  >
    <StyledTrack>
      <StyledRange />
    </StyledTrack>
    <StyledThumb onMouseLeave={onMouseLeave} onTouchEnd={onTouchEnd} />
  </StyledRoot>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }